export default __webpack_public_path__ + "static/media/our mission.0f1f4b3f.jpg";